<button
  *ngIf="canPrintOrder()"
  class="btn btn-sm btn-secondary ms-2 me-2"
  (click)="printOrder()"
  [title]="'measurementsGridButtonTitlePrintOrder' | localize"
  data-testid="print-order-button"
>
  <i class="fa fa-print"></i>
</button>
